import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
// import style from "./ReportIncome.module.css";
import moment from "moment";
import { fetchSupplierIncome } from "../../../redux";
import { Field, Form, Formik } from "formik";
import { DatePicker } from "antd";
import * as Yup from "yup";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  Button,
  CardTitle,
  CardText,
  Row,
  Col,
} from "reactstrap";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Select } from "antd";
import { checkIfPermitted, Permissions } from "../../../services/RolePermissionService";
import { formatNumberToCurrency } from "../../../utils/CommonUtil";

const { Option } = Select;


function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
  }`;
}

const model = {
    reportsOf: "",
    based_on: "",
    duration: "",
    dateFrom: "",
    dateTo: "",
  };

export class ReportIncome extends Component {
  constructor(props) {
    super(props);
    this.state = {
        ...model,
      page: 1,
      sortName: "",
      sortOrder: "",
      sortBy: "",
      isDataFetched: false,
      supplierIncome:[],
    };
    this.setLoader = this.setLoader.bind(this);
  }
  // Adding actions edit and delete icons
  actionsFormatter(cell, row) {
    return (
        <div>
        <Link title="View Details">
          <i className="fa fa-eye relatedpartylist-edit-icon"></i>
        </Link>
      </div>
    );
  }

  componentDidMount = async() => {
    
    const payload = this.getPayload();
    await this.props.fetchSupplierIncome(this.state.sortBy, this.state.page, payload);

    if(this.props.supplierIncomeData && 
      this.props.supplierIncomeData.supplierIncome &&
      this.props.supplierIncomeData.supplierIncome.inventory){
        this.setState({
          supplierIncome: this.props.supplierIncomeData.supplierIncome.inventory
        })
    }
    setTimeout(() => {
      if (this.props.supplierIncomeData.supplierIncome.total === 0) {
        this.setState({
          isDataFetched: true,
        });
      } else {
        this.setState({
          isDataFetched: false,
        });
      }
    }, 1000);

    
        //Updating parent state for export filters
        let parentPayload = {
          sortBy: this.state.sortBy,
          ...payload
      }
      this.props.updateParentState(parentPayload);
  }

  /**
   * This will return payload object.
   */
  getPayload = () => {
    return {
    dateFrom: dateFormatter(this.state.dateFrom),
    dateTo: dateFormatter(this.state.dateTo),
    reportsOf: this.state.reportsOf,
    based_on: this.state.based_on,
    duration: this.state.duration,
    };
  };

  callSupplierIncomeAPI = async() => {
    this.setState({
      supplierIncome: []
    })
    const payload = this.getPayload();
    await this.props.fetchSupplierIncome(this.state.sortBy, this.state.page, payload);

      if(!this.props.supplierIncomeData.loading){
          if(this.props.supplierIncomeData && 
            this.props.supplierIncomeData.supplierIncome && 
            this.props.supplierIncomeData.supplierIncome.inventory){
                this.setState({
                    supplierIncome:  this.props.supplierIncomeData.supplierIncome.inventory
                })
          }
        setTimeout(() => {
            this.setState({
              isDataFetched: true,
            });
        }, 500);
      }
    
      //Updating parent state for export filters
      let parentPayload = {
          sortBy: this.state.sortBy,
          ...payload
      }
      this.props.updateParentState(parentPayload);

  }
  
  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState({
      sortName,
      sortOrder,
      sortBy,
      page: 1,
      isDataFetched: false,
    },()=>{
      this.callSupplierIncomeAPI();
    });
    
  };

  onPageChange = (page, sizePerPage) => {
    this.setState({ 
      page,
      isDataFetched: false 
    },()=>{
      this.callSupplierIncomeAPI();
    });
  };


  handleInputChange = (event) => {
    let filterval = event.target.value;

    this.setState({
      view_by: filterval,
      page: 1,
      isDataFetched: false
    },()=>{
      this.callSupplierIncomeAPI();
    })
  }

  handleInputSelectChange = (event) => {
    let filterval = event.target.value;

    this.setState({
      [event.target.name]: filterval,
      page: 1,
      isDataFetched: false
    },()=>{
      this.callSupplierIncomeAPI();
    })
  }
  

  
  /**
   * This method will be called when date from filter is changed.
   */
  handleDateFrom = (date) => {
    this.setState(
      {
        dateFrom: date,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.callSupplierIncomeAPI();
      }
    );
  };

  /**
   * This method will be called when date to filter is changed.
   */
  handleDateTo = (date) => {
    this.setState(
      {
        dateTo: date,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.callSupplierIncomeAPI();
      }
    );
  };


  /**
   * This method will be called when view eye icon is clicked.
   * @param {object} val object data of the table row
   */
  viewAction = (val) => {
    // this.setState(
    //   (prevState) => ({
    //     payment_id: val.payment_id,
    //     isModalOpen: !prevState.isModalOpen,
    //   }),
    //   () => {
    //     if (this.state.isModalOpen) {
    //       this.props.fetchTransaction(val.payment_id);
    //     }
    //   }
    // );
  };

  /**
   * This method will be called when tab is changed.
   */
  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
        page: 1,
        sortName: undefined,
        sortOrder: undefined,
        sortBy: "",
        isDataFetched: false,
        ...model
      }, () => {
        this.callSupplierIncomeAPI();
      });
    }
  };


  /**
   * This method will be called when there is not data or data is being fetched to show the loader.
   */
  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLoader} alt='loader' className="loader-image" />
        </div>
      );
    }
  }

  /**
  * This method will be called to format the table data for valid data.
  * @param {string} data of the table column.
  * @returns {string} data or Not available string
  */
  checkValidData = (data) => {
    if (!data) {
      return "Not Available";
    } else {
      return data;
    }
  }

  /**
  * This method will be called to format the table data for valid data.
  * @param {string} data of the table column.
  * @returns {string} data with first letter capital or Not available string
  */
  detailFormatter = (data) => {
    if (!data) {
      return "Not Available";
    } else {
      return  data ? (data.charAt(0).toUpperCase() + data.slice(1)) : "Not Available";
    }
  }

  /**
   * This method will clear all the filters which are selected.
   */
  handleClearFilters = () => {
    this.setState({
      ...model,
      page: 1,
      sortName: "",
      sortOrder: "",
      sortBy: "",
      isDataFetched: false
    }, () => {
      this.callSupplierIncomeAPI();
    })
  }


    /**
   * This will return filter form HTML for the render method.
   */
  getSuppliesFilter = () => {
    
    return (
        <Formik>
          <div className={`row form-group `}>
                {(checkIfPermitted(Permissions.REPORT_BEST_SUPPLIES) || 
                checkIfPermitted(Permissions.REPORT_WORST_SUPPLIES)) && (
                <div className="col-sm-6 col-md-6 col-lg-4 mb-3">
                  <label>Reports of</label>
                  <Field
                    name="reportsOf"
                    as="select"
                    placeholder="reportsOf"
                    onChange={this.handleInputSelectChange}
                    className="form-control"
                    value={this.state.reportsOf}
                  >
                    <option value="">Select</option>
                    {checkIfPermitted(Permissions.REPORT_BEST_SUPPLIES) && (
                    <option value="1">Best Selling Supplies</option>
                    )}
                    {checkIfPermitted(Permissions.REPORT_WORST_SUPPLIES) && (
                    <option value="2">Worst Selling Supplies</option>
                    )}
                  </Field>
                </div>)}
                <div className="col-sm-6 col-md-6 col-lg-4 mb-3">
                  <label>Based on</label>
                  <Field
                    name="based_on"
                    as="select"
                    placeholder="Based on"
                    onChange={this.handleInputSelectChange}
                    className="form-control"
                    value={this.state.based_on}
                  >
                    <option value="">Select</option>
                    <option value="1">Earnings</option>
                    <option value="2">Quantity</option>
                  </Field>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-4 mb-3">
                  <label>Duration</label>
                  <Field
                    name="duration"
                    as="select"
                    onChange={this.handleInputSelectChange}
                    placeholder="duration"
                    className="form-control"
                    value={this.state.duration}
                  >
                    <option value="">Select</option>
                    <option value="1">Last Week</option>
                    <option value="2">Last Month</option>
                  </Field>
                </div>

            <div className="col-sm-6 col-md-6 col-lg-4 mb-3">
              <label>Date From</label>
              <DatePicker
                name="dateFrom"
                onChange={this.handleDateFrom}
                placeholder="Date From"
                className="form-control"
                value={this.state.dateFrom}
                disabledDate={(d) => !d || d.isAfter(this.state.dateTo)}
              />
            </div>

            <div className="col-sm-6 col-md-6 col-lg-4 mb-3">
              <label>Date To</label>
              <DatePicker
                name="dateTo"
                onChange={this.handleDateTo}
                placeholder="Date To"
                className="form-control"
                value={this.state.dateTo}
                disabledDate={(d) => !d || d.isBefore(this.state.dateFrom)}
              />
            </div>
          </div>
          </Formik>
    );
  };

  render() {
    const supplierIncomeData = this.props.supplierIncomeData.supplierIncome;
  
    return (
        <div className="inventory-tab-wrapper flex-wrap">
        <div className="row">
        <div className="col-md-12 d-flex justify-content-md-end">
              <a className="clearFilters"
                href="javascriptVoid:0"
                onClick={this.handleClearFilters}>
                Clear Filters
                </a>
            </div>
          <div className="col-md-12">
            {this.getSuppliesFilter()}
          </div>
        </div>

        <div className="row">
          <div className={`col-md-12`}>
            <BootstrapTable
            remote={true}
            bordered={false}
            data={this.state.supplierIncome}
            version="4"
            search={false}
            pagination
            fetchInfo={{
              dataTotalSize: supplierIncomeData.total,
            }}
            options={{
              searchvalue: "",
              sortName: this.state.sortName,
              sortOrder: this.state.sortOrder,
              onSortChange: this.onSortChange,
              // onSearchChange: this.onSearchChange,
              sizePerPage: 10,
              page: this.state.page,
              onPageChange: this.onPageChange,
              noDataText: this.setLoader(),
            }}>
              <TableHeaderColumn
                dataField="product_name"
                isKey={true}
                dataFormat={this.checkValidData}
                dataSort={true}
                width="30%"
              >
                Product
                </TableHeaderColumn>
              <TableHeaderColumn
                dataField="unique_code"
                dataFormat={this.checkValidData}
                dataSort={true}
                width="25%"
              >
                Unique Code
               </TableHeaderColumn>
              <TableHeaderColumn
                dataField="quantity"
                dataSort={true}
                dataFormat={this.checkValidData}
                width="25%"
              >
                Quantity
               </TableHeaderColumn>
              <TableHeaderColumn
                dataField="unit_price"
                dataSort={true}
                dataFormat={formatNumberToCurrency}
                width="30%"
              >
                Unit Price(ZAR)
               </TableHeaderColumn>
              <TableHeaderColumn
                dataField="amount"
                dataSort={true}
                dataFormat={formatNumberToCurrency}
                width="30%"
              >
                Earnings(ZAR)
               </TableHeaderColumn>
              {/* <TableHeaderColumn
                dataField="amount"
                dataSort={true}
                dataFormat={this.actionsFormatter}
              >
                Actions
               </TableHeaderColumn> */}
            </BootstrapTable>
          </div>
        </div>
      </div>
    );
  }
}

// export default Users;
const mapStateToProps = (state) => {
  return {
    supplierIncomeData: state.supplierIncome,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSupplierIncome: (sortBy, page, payload) => dispatch(fetchSupplierIncome(sortBy, page, payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportIncome);
